module.exports = __webpack_public_path__ + "img/11.6a3b8705.jpg";